import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivate } from '@angular/router';
import { merge, Observable, of } from 'rxjs';
import { AuthService } from './auth.service';
import { catchError, switchMap, take, takeWhile, tap } from 'rxjs/operators';
import { ROLES } from './roles';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  private roles:string[]=[];
  constructor(private auth: AuthService, private router: Router) {

  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean|UrlTree> | boolean {
    let minRole:number;

    return this.auth.isAuthenticated$.pipe(
      // tap( (loggedIn)=>{
      //
      // }),
      tap((loggedIn) => {
        if (!loggedIn) {
          return this.router.navigate(['login']);
        }else{
          if(next.data.hasOwnProperty('minRole')){
            minRole = next.data.minRole;
          }
          const highestRoleScore = Math.max.apply(Math,this.auth.roles.map((r:string)=>{
            return ROLES[r];
          }));
          if(highestRoleScore < minRole){
              return  this.router.navigate(['..']);
          }
        }
      }),
      catchError((err) => {
       this.router.navigate(['/login']);
       return of(false);
     })
    );
  }

}
